module.exports = __webpack_public_path__ + "static/media/BovExo_template_animais.167491aa.xlsx";